import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Bruksenhet from './Bruksenhet.jsx'
import BruksenhetIcon from '../../../images/Bruksenhet.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class BruksenhetList extends Component {
    state = {
        bruksenheter: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null
    }

    getBruksenheter = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/adresse/${this.props.adresseId}/bruksenhet`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken
            }
        })
        .then(({data}) => {
            this.setState({
                bruksenheter: [...this.state.bruksenheter, ...data.bruksenheter],
                isLoading: false,
                continuationToken: data.nextContinuationToken})
        })
      }


    toggleBruksenheter = () => {
        if (this.props.antall == 0) return
                
        if (this.state.bruksenheter.length == 0) {
            this.getBruksenheter()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    kopierBruksenheter = event => {
        event.stopPropagation()

        if (this.state.bruksenheter.length == 0) return;
        const replacer = (key, value) => value === null ? '' : value
        const header = Object.keys(this.state.bruksenheter[0])
        const csv = [
          header.join(','),
          ...this.state.bruksenheter.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
        ].join('\r\n')
        
        navigator.clipboard.writeText(csv)
    }

    render() {
        const { t } = this.props        
        var antallBruksenheter = this.state.continuationToken ? `${this.state.bruksenheter.length}/${this.props.antall}` : this.props.antall
        return (
            <li>
                <div className="section-header" onClick={this.toggleBruksenheter}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={BruksenhetIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('bruksenheter')} ({antallBruksenheter})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                    { this.state.isOpened &&
                    <div className="icon-image right tooltip" onClick={this.kopierBruksenheter}>
                        <i className="fa fa-clipboard"></i>
                        <div className="tooltip-content">{t('vis.kopierbruksenheter')}</div>
                    </div> }
                </div>
                <div className={this.state.isOpened && this.state.bruksenheter.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.bruksenheter.map((b, index) => { return (<Bruksenhet key={b.bruksenhetId} bruksenhet={b} antall={this.props.antall} isLast={index==this.state.bruksenheter.length-1} onEvent={this.props.onEvent} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getBruksenheter}>
                                <span>{t('hent.bruksenheter')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(BruksenhetList)